import React from "react";
import {Canvas, useThree} from "@react-three/fiber";
import {Environment, ContactShadows} from "@react-three/drei";
import ModelsContainer from "./components/models/ModelsContainer";

// NOTE "studio_small_05_1k.hdr" is not a good image (too dark)

// you may want to consider changing it
// there are some in "node modules @react-three/drei" somewhere

// NOTE light / lights are needed - they will go inside the canvas component

function Camera()
{
  const {camera, controls} = useThree();
  //camera.position.x = -10.148739181273616;
  camera.position.y = 1.2786790215118056;
  //camera.position.y = 4.28536345854463;
  camera.position.z = 2.413643028751059;
  //camera.position.z = 0;
  if(controls) controls.target.y = 0.7;
}

const Scene = () => {
  console.log(Scene);
  return (
    
    <div className="main-container">
      <div className="scene-container">
        <Canvas shadows={"percentage"}>
          
            <ModelsContainer/>
            <ambientLight intensity={0.2} />
            <directionalLight 
              intensity={1.5} 
              position={[-5, 3.5, 5]}
              castShadow
              shadow-bias={-0.0005}
              shadow-camera-far={10}
              shadow-camera-near={6}
              shadow-camera-top={2}
              shadow-camera-bottom={-0.5}
              shadow-camera-right={1.5}
              shadow-camera-left={-1}
              shadow-mapSize-height={2048}
              shadow-mapSize-width={2048}
              shadow-radius={3}/>
            <directionalLight 
              intensity={0.5} 
              position={[5, -3.5, -5]}/>
            {/* <directionalLight 
              intensity={0.35} 
              position={[-5, 3.5, 5]}/> */}
            {/* <directionalLight intensity={0.5} position={[2.5, 3, 5]}/>
            <directionalLight 
              intensity={2}
              position={[-2.5, 3, 5]}
              castShadow
              shadow-bias={-0.0002}
              shadow-camera-far={8}
              shadow-camera-near={5}
              shadow-camera-top={2}
              shadow-camera-bottom={-0.5}
              shadow-camera-right={1}
              shadow-camera-left={-1}
              shadow-mapSize-height={4096}
              shadow-mapSize-width={4096}
              shadow-radius={3} />
            <directionalLight intensity={0.5} position={[0, 3, -5]} /> */}

            <ContactShadows opacity={0.4} scale={20} blur={1} far={10} resolution={256} color="#000000" />
            
            {/* <Environment
              background={false}
              files={'studio_small_05_1k.hdr'}
              path={'./'}
            /> */}
            
        </Canvas>
      </div>
    </div>
  );
  
}

export default Scene;
